// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 608) return "static/chunks/608-194e1bdc2a0b27c5.js";
	if (chunkId === 505) return "static/chunks/505-892ea49d18210479.js";
	if (chunkId === 784) return "static/chunks/784-b2753d6e9b47bed8.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","628":"b645e135"}[chunkId] || chunkId) + "." + {"32":"38c86f6f7f3ad4af","154":"2bd4240ae78391c0","316":"2cf0d2625664d51a","628":"5814e1fbc90dd815"}[chunkId] + ".js";
};